import { useEffect } from "react";

/**
 * Custom hook to restore focus to an input field after validation errors cause defocus.
 *
 * This hook ensures that if an input field was previously focused, it regains focus
 * after a validation update. This is useful in cases where validation triggers an
 * input blur, leading to an undesired user experience.
 *
 * @param {Object} params - Parameters object.
 * @param {string | Object} params.error - Validation error state that may trigger focus loss.
 * @param {string} params.focusedField - Name attribute of the input field that should regain focus.
 */
export const useFocusedField = ({ error, focusedField }) => {
  useEffect(() => {
    if (focusedField) {
      const inputElement = document.querySelector(
        `input[name="${focusedField}"]`
      );
      if (inputElement) {
        inputElement.focus();
      }
    }
  }, [error, focusedField]);
};
